import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbDatepickerModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import {
  PageService,
  SortService,
  ResizeService,
  FilterService,
  ColumnChooserService
} from '@syncfusion/ej2-angular-grids';

// import { DateFormatService } from '../../date.service';
import { EligibilityLogsComponent } from './eligibility-logs.component';
import { EligibilityLogsRoutingModule } from './eligibility-logs-routing.module';
import { DateFormatService } from 'src/app/service/dateformat.service';

@NgModule({
  declarations: [
    EligibilityLogsComponent
  ],
  imports: [
    CommonModule,
    EligibilityLogsRoutingModule,
    GridModule,
    MaskedTextBoxModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    NgbDatepickerModule,
  ],
  providers: [
    PageService,
    SortService,
    ResizeService,
    FilterService,
    ColumnChooserService,
    { provide: NgbDateParserFormatter, useClass: DateFormatService },
  ]
})
export class EligibilityLogsModule { }
